'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('antd');

var _reactRouterDom = require('react-router-dom');

var _themes = require('../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _googlePlayBadge = require('../../images/google-play-badge.png');

var _googlePlayBadge2 = _interopRequireDefault(_googlePlayBadge);

var _SocialMedia = require('../SocialMedia');

var _SocialMedia2 = _interopRequireDefault(_SocialMedia);

var _modals = require('shared/hoc/modals');

var _modals2 = _interopRequireDefault(_modals);

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _urlLocations = require('../../routes/urlLocations');

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

var _LogoTextOnly = require('../Icons/LogoTextOnly');

var _LogoTextOnly2 = _interopRequireDefault(_LogoTextOnly);

var _PdfPreviewPopup = require('../PdfPreviewPopup');

var _PdfPreviewPopup2 = _interopRequireDefault(_PdfPreviewPopup);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var pointTo = function pointTo(elementId) {
  window.location.href = "#".concat(elementId);
};

var iconStyle = {
  fill: '#FFFFFF',
  cursor: 'pointer',
  outline: 'none',
  display: 'flex'
};
var correctYear = new Date().getFullYear();

var getCopyrightText = function getCopyrightText(spPlatformConfig) {
  var subDomain = spPlatformConfig && spPlatformConfig.subDomain || 'finbursa';
  return "Copyright \xA9 ".concat(correctYear, " ").concat((0, _capitalize2.default)(subDomain), ".");
};

var onLinkClick = function onLinkClick() {
  pointTo('header');
};

var Footer =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Footer, _react$Component);

  function Footer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Footer);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Footer)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      showTerms: false,
      showPrivacy: false
    }, _this.togglePopupTerms = function () {
      _this.setState({
        showTerms: !_this.state.showTerms
      });
    }, _this.togglePopupPrivacy = function () {
      _this.setState({
        showPrivacy: !_this.state.showPrivacy
      });
    }, _temp));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userTheme = _this$props.userTheme,
          absolute = _this$props.absolute,
          staticPlatform = _this$props.staticPlatform,
          modals = _this$props.modals,
          spPlatformConfig = _this$props.spPlatformConfig;
      var _this$state = this.state,
          showTerms = _this$state.showTerms,
          showPrivacy = _this$state.showPrivacy;
      return _react2.default.createElement(_styled2.default.FooterContainer, {
        userTheme: userTheme,
        absolute: absolute
      }, _react2.default.createElement(_styled2.default.RowContainer, null, _react2.default.createElement(_styled2.default.ColLogo, {
        spPlatformConfig: spPlatformConfig
      }, _react2.default.createElement(_styled2.default.Logo, null, spPlatformConfig && spPlatformConfig.logo && spPlatformConfig.logo.link ? _react2.default.createElement('img', {
        src: spPlatformConfig.logo.link
      }) : _react2.default.createElement(_LogoTextOnly2.default, null)), _react2.default.createElement('div', null, _react2.default.createElement('span', null, getCopyrightText(spPlatformConfig)), _react2.default.createElement('br', null), _react2.default.createElement('span', null, 'All rights reserved.'))), _react2.default.createElement(_antd.Col, null, !spPlatformConfig && _react2.default.createElement(_styled2.default.ColumnTitle, null, 'CONTACT US'), _react2.default.createElement(_styled2.default.ContactUsButton, {
        spPlatformConfig: spPlatformConfig,
        onClick: function onClick() {
          return modals.open('ContanctUsModal');
        }
      }, spPlatformConfig ? 'Contact us' : 'Send message')), _react2.default.createElement(_styled2.default.ColStaticLinks, null, !spPlatformConfig && _react2.default.createElement(_styled2.default.ColumnTitle, null, 'TERMS AND PRIVACY'), _react2.default.createElement(_styled2.default.LinkWrapper, null, spPlatformConfig ? _react2.default.createElement('div', null, _react2.default.createElement('a', {
        onClick: this.togglePopupTerms
      }, 'Terms of Service'), showTerms ? _react2.default.createElement(_PdfPreviewPopup2.default, {
        spPlatformConfig: spPlatformConfig,
        link: spPlatformConfig.termsOfServiceDocument.link,
        width: 530,
        closePopup: this.togglePopupTerms
      }) : null) : _react2.default.createElement(_reactRouterDom.Link, {
        to: {
          pathname: "//".concat(window.WEB_URL).concat(_urlLocations.termsOfUse),
          hash: '#blank'
        },
        target: '_blank'
      }, 'Terms of Service')), _react2.default.createElement(_styled2.default.LinkWrapper, null, spPlatformConfig ? _react2.default.createElement('div', null, _react2.default.createElement('a', {
        onClick: this.togglePopupPrivacy
      }, 'Privacy Policy'), showPrivacy ? _react2.default.createElement(_PdfPreviewPopup2.default, {
        spPlatformConfig: spPlatformConfig,
        link: spPlatformConfig.privacyPolicyDocument.link,
        width: 530,
        closePopup: this.togglePopupPrivacy
      }) : null) : _react2.default.createElement(_reactRouterDom.Link, {
        to: {
          pathname: "//".concat(window.WEB_URL).concat(_urlLocations.privacy),
          hash: '#blank'
        },
        target: '_blank'
      }, 'Privacy Policy')), _react2.default.createElement('div', null, _react2.default.createElement(_reactRouterDom.Link, {
        to: {
          pathname: "//".concat(window.WEB_URL).concat(_urlLocations.cookie),
          hash: '#blank'
        },
        target: '_blank'
      }, 'Cookie Policy'))), !spPlatformConfig && _react2.default.createElement(_styled2.default.ColNetwork, null, _react2.default.createElement(_styled2.default.ColumnTitle, null, 'NETWORK'), _react2.default.createElement('div', null, _react2.default.createElement('a', {
        target: '_blank'
      }, 'Facebook')), _react2.default.createElement('div', null, _react2.default.createElement('a', {
        target: '_blank'
      }, 'LinkedIn'))), !spPlatformConfig && _react2.default.createElement(_styled2.default.ColSocialMedia, null, _react2.default.createElement(_SocialMedia2.default, {
        linkedIn: iconStyle,
        facebook: iconStyle
      }))));
    }
  }]);

  return Footer;
}(_react.Component);

Footer.defaultProps = {
  staticPlatform: false,
  userTheme: _themes2.default.WHITE,
  absolute: false,
  showTerms: false,
  showPrivacy: false
};
Footer.propTypes = {
  absolute: _propTypes2.default.bool,
  showPrivacy: _propTypes2.default.bool,
  showTerms: _propTypes2.default.bool,
  staticPlatform: _propTypes2.default.bool,
  userTheme: _propTypes2.default.oneOf([_themes2.default.WHITE, _themes2.default.BLACK])
};
Footer.displayName = 'Footer';
exports.default = (0, _modals2.default)(Footer);